import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const EventsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const eventTypes = [
    {
      icon: 'ri-vip-crown-fill',
      title: 'Soirées Privées VIP',
      description: 'Événements exclusifs sur péniches et rooftops parisiens avec vue imprenable',
      features: ['DJ professionnel', 'Service traiteur premium', 'Décoration sur-mesure', 'Sécurité privée']
    },
    {
      icon: 'ri-rocket-fill',
      title: 'Lancements de Produits',
      description: 'Showcases et événements corporate pour marquer les esprits',
      features: ['Scénographie unique', 'Couverture média', 'Influenceurs', 'Live streaming']
    },
    {
      icon: 'ri-cake-3-fill',
      title: 'Anniversaires Exceptionnels',
      description: 'Célébrations inoubliables dans des lieux d\'exception',
      features: ['Thématique personnalisée', 'Animation sur-mesure', 'Photographe pro', 'Cadeaux VIP']
    },
    {
      icon: 'ri-briefcase-fill',
      title: 'Événements Corporate',
      description: 'Séminaires, team building et soirées d\'entreprise premium',
      features: ['Organisation clé en main', 'Activités team building', 'Conférenciers', 'Networking']
    },
    {
      icon: 'ri-heart-3-fill',
      title: 'Mariages & Fiançailles',
      description: 'Le jour le plus important de votre vie, orchestré à la perfection',
      features: ['Wedding planner dédié', 'Lieux romantiques', 'Coordination totale', 'Souvenirs éternels']
    },
    {
      icon: 'ri-music-fill',
      title: 'Festivals & Concerts',
      description: 'Événements musicaux et culturels de grande envergure',
      features: ['Artistes renommés', 'Sonorisation pro', 'Billetterie', 'Logistique complète']
    }
  ];

  const services = [
    { icon: 'ri-music-2-fill', title: 'DJ & Sonorisation', desc: 'Ambiance musicale premium' },
    { icon: 'ri-camera-fill', title: 'Photo & Vidéo', desc: 'Capturer chaque instant' },
    { icon: 'ri-palette-fill', title: 'Décoration', desc: 'Design sur-mesure' },
    { icon: 'ri-restaurant-fill', title: 'Traiteur Gastronomique', desc: 'Cuisine d\'exception' },
    { icon: 'ri-shield-check-fill', title: 'Sécurité', desc: 'Équipe professionnelle' },
    { icon: 'ri-car-fill', title: 'Transport VIP', desc: 'Navettes et voituriers' },
    { icon: 'ri-lightbulb-flash-fill', title: 'Éclairage Scénique', desc: 'Effets lumineux spectaculaires' },
    { icon: 'ri-gift-fill', title: 'Cadeaux & Goodies', desc: 'Souvenirs personnalisés' }
  ];

  const venues = [
    {
      name: 'Péniche Seine Exclusive',
      location: 'Port de Solférino, Paris 7e',
      capacity: '150 personnes',
      price: 'À partir de 8 000€',
      image: 'https://public.readdy.ai/ai/img_res/ba40ee08128535094988551f18dfd65a.jpg',
      features: ['Vue Tour Eiffel', 'Terrasse panoramique', 'Cuisine équipée', 'Sonorisation']
    },
    {
      name: 'Rooftop Champs-Élysées',
      location: 'Avenue des Champs-Élysées, Paris 8e',
      capacity: '200 personnes',
      price: 'À partir de 12 000€',
      image: 'https://readdy.ai/api/search-image?query=luxury%20rooftop%20terrace%20venue%20on%20Champs-Elysees%20Paris%2C%20exclusive%20rooftop%20party%20space%20with%20Arc%20de%20Triomphe%20view%2C%20elegant%20outdoor%20event%20venue%20Paris%2C%20premium%20rooftop%20bar%20and%20lounge%2C%20sophisticated%20urban%20terrace%2C%20upscale%20rooftop%20celebration%2C%20cinematic%20sunset%20over%20Paris%20skyline%2C%20golden%20hour%20rooftop%20photography&width=800&height=600&seq=vybe-event-rooftop-001&orientation=landscape',
      features: ['Vue Arc de Triomphe', 'Bar premium', 'Lounge VIP', 'Chauffage extérieur']
    },
    {
      name: 'Loft Industriel Marais',
      location: 'Le Marais, Paris 3e',
      capacity: '120 personnes',
      price: 'À partir de 6 000€',
      image: 'https://readdy.ai/api/search-image?query=industrial%20loft%20event%20venue%20in%20Le%20Marais%20Paris%2C%20modern%20warehouse%20space%20for%20private%20events%2C%20contemporary%20urban%20loft%20with%20exposed%20brick%2C%20stylish%20industrial%20event%20space%2C%20premium%20loft%20party%20venue%2C%20sophisticated%20warehouse%20conversion%2C%20elegant%20industrial%20interior%20design%2C%20professional%20event%20photography&width=800&height=600&seq=vybe-event-loft-001&orientation=landscape',
      features: ['Style industriel', 'Hauteur sous plafond', 'Modulable', 'Parking privé']
    },
    {
      name: 'Château Île-de-France',
      location: 'Vexin Français, 45min de Paris',
      capacity: '300 personnes',
      price: 'À partir de 15 000€',
      image: 'https://readdy.ai/api/search-image?query=elegant%20French%20chateau%20wedding%20venue%20near%20Paris%2C%20luxury%20castle%20event%20space%20in%20Ile-de-France%2C%20romantic%20chateau%20for%20celebrations%2C%20premium%20historic%20venue%20with%20gardens%2C%20sophisticated%20French%20castle%20interior%2C%20upscale%20chateau%20reception%2C%20cinematic%20photography%20of%20French%20estate%2C%20golden%20hour%20chateau%20exterior&width=800&height=600&seq=vybe-event-chateau-001&orientation=landscape',
      features: ['Parc arboré', 'Hébergement', 'Salle de réception', 'Chapelle']
    }
  ];

  const recentEvents = [
    {
      title: 'Lancement LVMH x Influenceurs',
      date: 'Décembre 2024',
      guests: '180 invités',
      image: 'https://readdy.ai/api/search-image?query=luxury%20brand%20product%20launch%20event%20with%20influencers%2C%20LVMH%20style%20exclusive%20party%2C%20high-end%20fashion%20event%20with%20celebrities%2C%20premium%20brand%20showcase%2C%20sophisticated%20corporate%20event%2C%20elegant%20product%20presentation%2C%20professional%20event%20photography%2C%20golden%20lighting%20luxury%20atmosphere&width=600&height=400&seq=vybe-event-recent-001&orientation=landscape'
    },
    {
      title: 'Mariage Royal Péniche',
      date: 'Novembre 2024',
      guests: '120 invités',
      image: 'https://readdy.ai/api/search-image?query=elegant%20wedding%20reception%20on%20Seine%20river%20p%C3%A9niche%20Paris%2C%20romantic%20boat%20wedding%20with%20Eiffel%20Tower%2C%20luxury%20floating%20wedding%20venue%2C%20sophisticated%20wedding%20celebration%20on%20water%2C%20premium%20wedding%20photography%20Paris%2C%20golden%20hour%20wedding%20on%20Seine%2C%20cinematic%20wedding%20atmosphere&width=600&height=400&seq=vybe-event-recent-002&orientation=landscape'
    },
    {
      title: 'Soirée Anniversaire 30 ans VIP',
      date: 'Octobre 2024',
      guests: '200 invités',
      image: 'https://readdy.ai/api/search-image?query=VIP%20birthday%20party%20celebration%20on%20luxury%20rooftop%20Paris%2C%20exclusive%2030th%20birthday%20event%2C%20premium%20party%20with%20DJ%20and%20lights%2C%20sophisticated%20nightlife%20celebration%2C%20elegant%20birthday%20bash%2C%20professional%20party%20photography%2C%20golden%20and%20purple%20lighting%2C%20upscale%20celebration%20atmosphere&width=600&height=400&seq=vybe-event-recent-003&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      
      <main className="pt-20">
        {/* Hero Section with 3D Animation */}
        <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-[#0A0A0A]/80 to-[#0A0A0A] z-10"></div>
            <img
              src="https://readdy.ai/api/search-image?query=luxury%20VIP%20rooftop%20party%20in%20Paris%20at%20night%2C%20exclusive%20private%20event%20on%20Seine%20river%20p%C3%A9niche%2C%20elegant%20celebration%20with%20golden%20lighting%2C%20premium%20event%20venue%20with%20Eiffel%20Tower%20view%2C%20sophisticated%20nightlife%20gathering%2C%20high-end%20corporate%20event%2C%20stylish%20celebration%20atmosphere%2C%20professional%20event%20photography%2C%20cinematic%20party%20lighting%2C%20modern%20luxury%20celebration&width=1920&height=1080&seq=vybe-event-hero-001&orientation=landscape"
              alt="VYBE ÉVENT"
              className="w-full h-full object-cover animate-slow-zoom"
              loading="eager"
            />
          </div>

          {/* Floating 3D Elements */}
          <div className="absolute inset-0 pointer-events-none z-20">
            <div className="absolute top-20 left-10 w-24 h-24 bg-gradient-to-br from-purple-500/30 to-pink-500/30 rounded-full blur-2xl animate-float"></div>
            <div className="absolute bottom-40 right-20 w-32 h-32 bg-gradient-to-br from-rose-500/20 to-purple-500/20 rounded-full blur-3xl animate-float-delayed"></div>
          </div>

          <div className="relative z-30 text-center px-4 max-w-6xl mx-auto">
            <div className="mb-8 animate-fade-in-up">
              <div className="inline-block px-8 py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full mb-6">
                <span className="text-white font-bold text-sm tracking-wider flex items-center gap-2">
                  <i className="ri-goblet-fill text-xl"></i>
                  ÉVÉNEMENTIEL D'EXCEPTION
                </span>
              </div>
              
              <h1 className="text-6xl md:text-8xl lg:text-9xl font-black mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-rose-400 bg-clip-text text-transparent">
                  VYBE ÉVENT
                </span>
              </h1>
              
              <p className="text-2xl md:text-4xl text-white/90 mb-8 font-light">
                Créateur d'événements inoubliables
              </p>
              
              <p className="text-lg md:text-xl text-white/70 max-w-3xl mx-auto mb-12">
                Soirées privées sur péniches, rooftops parisiens, showcases exclusifs. 
                Organisation clé en main d'événements corporate, mariages VIP et célébrations d'exception.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 justify-center animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
              <a
                href="#contact"
                className="group px-10 py-5 bg-gradient-to-r from-purple-500 via-pink-500 to-rose-500 text-white font-bold rounded-2xl hover:scale-105 transition-all duration-500 shadow-2xl hover:shadow-purple-500/50"
              >
                <span className="flex items-center gap-3">
                  <i className="ri-calendar-check-fill text-2xl"></i>
                  Demander un Devis
                  <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform"></i>
                </span>
              </a>
              
              <a
                href="#venues"
                className="group px-10 py-5 bg-white/10 backdrop-blur-xl text-white font-bold rounded-2xl border border-white/20 hover:scale-105 transition-all duration-500 hover:bg-white/20"
              >
                <span className="flex items-center gap-3">
                  <i className="ri-map-pin-fill text-2xl"></i>
                  Découvrir nos Lieux
                </span>
              </a>
            </div>
          </div>

          <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-30 animate-bounce">
            <div className="w-14 h-14 rounded-full border-2 border-purple-400 flex items-center justify-center bg-[#0A0A0A]/50 backdrop-blur-sm">
              <i className="ri-arrow-down-line text-purple-400 text-2xl"></i>
            </div>
          </div>
        </section>

        {/* Event Types Section */}
        <section className="py-32 px-4 bg-gradient-to-b from-[#0A0A0A] to-[#0F0F0F]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <span className="text-purple-400 text-sm font-bold tracking-widest uppercase">Nos Services</span>
              <h2 className="text-5xl md:text-7xl font-black text-white mt-4 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Types d'<span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Événements</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {eventTypes.map((type, idx) => (
                <div
                  key={type.title}
                  className="group relative animate-fade-in-up opacity-0"
                  style={{ animationDelay: `${idx * 0.1}s` }}
                >
                  <div className="absolute -inset-1 bg-gradient-to-r from-purple-500 to-pink-500 opacity-0 group-hover:opacity-75 blur-xl transition-opacity duration-500 rounded-3xl"></div>
                  
                  <div className="relative bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-xl rounded-3xl p-8 border border-white/20 hover:scale-105 transition-all duration-500 h-full">
                    <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center mb-6 group-hover:rotate-12 transition-transform duration-500">
                      <i className={`${type.icon} text-3xl text-white`}></i>
                    </div>
                    
                    <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {type.title}
                    </h3>
                    
                    <p className="text-white/70 mb-6 leading-relaxed">
                      {type.description}
                    </p>
                    
                    <ul className="space-y-3">
                      {type.features.map((feature) => (
                        <li key={feature} className="flex items-center gap-3 text-white/60">
                          <i className="ri-checkbox-circle-fill text-purple-400"></i>
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-32 px-4 bg-[#0F0F0F]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-5xl md:text-7xl font-black text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Services <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Clé en Main</span>
              </h2>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {services.map((service, idx) => (
                <div
                  key={service.title}
                  className="group text-center p-6 bg-gradient-to-br from-white/5 to-white/10 backdrop-blur-xl rounded-2xl border border-white/20 hover:scale-105 transition-all duration-500"
                >
                  <i className={`${service.icon} text-5xl text-purple-400 mb-4 block group-hover:scale-110 transition-transform`}></i>
                  <h4 className="text-white font-bold mb-2">{service.title}</h4>
                  <p className="text-white/60 text-sm">{service.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Venues Section */}
        <section id="venues" className="py-32 px-4 bg-gradient-to-b from-[#0F0F0F] to-[#0A0A0A]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <span className="text-purple-400 text-sm font-bold tracking-widest uppercase">Lieux d'Exception</span>
              <h2 className="text-5xl md:text-7xl font-black text-white mt-4 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Nos <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Venues</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {venues.map((venue, idx) => (
                <div
                  key={venue.name}
                  className="group relative overflow-hidden rounded-3xl"
                >
                  <div className="absolute -inset-1 bg-gradient-to-r from-purple-500 to-pink-500 opacity-0 group-hover:opacity-75 blur-xl transition-opacity duration-500"></div>
                  
                  <div className="relative">
                    <div className="relative h-80 overflow-hidden">
                      <img
                        src={venue.image}
                        alt={venue.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                        loading="lazy"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent"></div>
                      
                      <div className="absolute top-6 right-6 px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full">
                        <span className="text-white font-bold text-sm">{venue.price}</span>
                      </div>
                    </div>
                    
                    <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-xl p-8 border-t border-white/20">
                      <h3 className="text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        {venue.name}
                      </h3>
                      
                      <div className="flex items-center gap-2 text-white/60 mb-2">
                        <i className="ri-map-pin-fill text-purple-400"></i>
                        <span>{venue.location}</span>
                      </div>
                      
                      <div className="flex items-center gap-2 text-white/60 mb-6">
                        <i className="ri-group-fill text-purple-400"></i>
                        <span>{venue.capacity}</span>
                      </div>
                      
                      <div className="flex flex-wrap gap-3">
                        {venue.features.map((feature) => (
                          <span
                            key={feature}
                            className="px-4 py-2 bg-white/10 rounded-full text-white/80 text-sm border border-white/20"
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Recent Events Gallery */}
        <section className="py-32 px-4 bg-[#0A0A0A]">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-20">
              <h2 className="text-5xl md:text-7xl font-black text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Événements <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Récents</span>
              </h2>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              {recentEvents.map((event, idx) => (
                <div
                  key={event.title}
                  className="group relative overflow-hidden rounded-3xl"
                >
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-96 object-cover group-hover:scale-110 transition-transform duration-700"
                    loading="lazy"
                  />
                  
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent"></div>
                  
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h3 className="text-2xl font-bold text-white mb-2">{event.title}</h3>
                    <div className="flex items-center gap-4 text-white/70 text-sm">
                      <span className="flex items-center gap-2">
                        <i className="ri-calendar-fill text-purple-400"></i>
                        {event.date}
                      </span>
                      <span className="flex items-center gap-2">
                        <i className="ri-group-fill text-purple-400"></i>
                        {event.guests}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section id="contact" className="py-32 px-4 bg-gradient-to-b from-[#0A0A0A] to-[#0F0F0F]">
          <div className="max-w-4xl mx-auto text-center">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-purple-500 via-pink-500 to-rose-500 blur-3xl opacity-20"></div>
              
              <div className="relative bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-2xl rounded-3xl p-12 md:p-16 border border-white/20">
                <i className="ri-sparkling-2-fill text-6xl text-purple-400 mb-6 inline-block animate-pulse"></i>
                
                <h2 className="text-4xl md:text-6xl font-black text-white mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Prêt à créer votre <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">événement</span> ?
                </h2>
                
                <p className="text-xl text-white/80 mb-10">
                  Contactez-nous pour un devis personnalisé et transformons votre vision en réalité
                </p>
                
                <div className="flex flex-col sm:flex-row gap-6 justify-center">
                  <Link
                    to="/contact"
                    className="group px-10 py-5 bg-gradient-to-r from-purple-500 via-pink-500 to-rose-500 text-white font-bold rounded-2xl hover:scale-105 transition-all duration-500 shadow-2xl"
                  >
                    <span className="flex items-center gap-3">
                      <i className="ri-mail-fill text-2xl"></i>
                      Demander un Devis
                      <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform"></i>
                    </span>
                  </Link>
                  
                  <a
                    href="tel:+33123456789"
                    className="group px-10 py-5 bg-white/10 backdrop-blur-xl text-white font-bold rounded-2xl border border-white/20 hover:scale-105 transition-all duration-500"
                  >
                    <span className="flex items-center gap-3">
                      <i className="ri-phone-fill text-2xl"></i>
                      Appeler Maintenant
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <style>{`
        @keyframes slow-zoom {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-30px); }
        }
        
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(50px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-slow-zoom {
          animation: slow-zoom 20s ease-in-out infinite;
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        .animate-float-delayed {
          animation: float-delayed 8s ease-in-out infinite;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 1s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default EventsPage;
